import React from 'react'
import {Link} from 'react-router-dom'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import injectSheet from 'react-jss'
import classNames from 'classnames'
import capitalize from 'lodash-es/capitalize'
import routesHelper from '@prepler/core/lib/routesHelper'
import {destroyGoal} from '@prepler/core/lib/actions/learning/goalActions'
import {universitySelector} from '@prepler/core/lib/reducers/universitiesReducer'
import {getStudyComplexityName} from '@prepler/core/lib/constants/studyComplexityTypes'
import HelpCircle from '../../common/helpCircle'
import {AppConfig} from '../../../config'
import styles from './indexStyles'

class GoalLink extends React.Component {
	renderMajors() {
		const {goal, classes} = this.props;
		return <div className={classes.goalDegrees}>
			{goal.major_groups.map(({id, degree_group: degreeGroup, major}) => {
				if (!degreeGroup && !major) {
					return (
						<div key={id}>
							<p className={classes.error}>
								Current major/minor was deleted by moderator.
							</p>
							<p className={classes.error}>
								If you feel like you have lost valuable information, please <Link to={routesHelper.contactUsPath()}>contact us</Link>.
							</p>
						</div>
					)
				}
				const {major_type: majorType, degree, comment} = degreeGroup || {major_type: 'N/A', degree: 'N/A', comment: 'N/A'};
				const {title, root_title: rootTitle, comment: majorComment} = major || {title: 'N/A', root_title: 'N/A', comment: 'N/A'};
				return (
					<div key={id}>
						<p>
							<strong>{capitalize(majorType)}: {rootTitle}</strong>
						</p>
						<div className={classes.p}>
							{title}
							{majorComment && <HelpCircle>{majorComment}</HelpCircle>}
						</div>
						<div className={classNames(classes.p, classes.blue)}>
							Degree: {degree}
							{comment && <HelpCircle>{comment}</HelpCircle>}
						</div>
					</div>
				);
			})}
		</div>;
	}

	renderMyMajors() {
		const {goal, classes} = this.props;
		return <div className={classes.goalDegrees}>
			{goal.major_groups.map(({id, my_major: {major_type: majorType, degree, title}}) => (
				<div key={id}>
					<p>
						<strong>{capitalize(majorType)}: </strong> {title}
					</p>
					<p className={classes.blue}>Degree: {degree}</p>
				</div>
			))}
		</div>;
	}

	render() {
		// eslint-disable-next-line camelcase
		const {classes, goal, university, token, actions: {destroyGoal}} = this.props;
		if (university) {
			return (
				<div className={classes.goalBox}>
					<div className={classes.goalPicture}>
						<Link to={routesHelper.goalPath({id: goal.slug || goal.id})}>
							{university && <img alt={`${university.name} logo`} src={university.photo_2x} className={classes.goalImg} />}
						</Link>
					</div>
					<div className={classes.goalContent}>
						<div className={classes.goalTitle}>
							<div>
								<Link to={routesHelper.goalPath({id: goal.slug || goal.id})}>{goal.name}</Link>
								<span className={classes.goalTitleFine}>(open to edit)</span>
								<p>{university.name} ({university.city}, {university.state_abbr})</p>
							</div>
							{goal.settings.study_complexity && <div>
								Study Load: <span className={classes.studyMode}>{getStudyComplexityName(goal.settings.study_complexity)}</span>
							</div>}
						</div>
						{goal.goal_type === 'manual' ? this.renderMyMajors() : this.renderMajors()}
						<div className={classes.goalFooter}>
							<div>
								<p>Created: {new Date(Date.parse(goal.created_at)).toLocaleDateString('en-US')}</p>
								<p>Last modified: {new Date(Date.parse(goal.updated_at)).toLocaleDateString('en-US')}</p>
								<p>
									<Link to={routesHelper.universityPath({id: university.slug || university.id})}>
										College Profile
									</Link>
								</p>
							</div>
							<div className={classes.goalActions}>
								<Link to={routesHelper.goalDuplicatePath({id: goal.slug || goal.id})}>
									<img alt="" src={require('../../../assets/images/goals/show.png')} />
									<br />
									Duplicate
								</Link>
								<a href={`${AppConfig.apiURL}${routesHelper.goalExportPath({id: goal.id, token})}`}>
									<img alt="" src={require('../../../assets/images/goals/pdf.png')} />
									<br />
									Export to PDF
								</a>
								{goal.access.destroy && <a onClick={() => window.confirm(`Are you sure that you want to permanently delete "${goal.name}" goal?`) && destroyGoal(goal)} className={classes.deleteLink}>
									<img alt="" src={require('../../../assets/images/goals/delete.png')} />
									<br />
									Delete
								</a>}
							</div>
						</div>
					</div>
				</div>
			);
		} else {
			return <div />
		}
	}
}

function mapStateToProps(state, ownProps) {
	const {token} = state.auth;
	const {goal} = ownProps;
	if (goal) {
		return {
			goal,
			university: universitySelector(state, goal.university_id),
			token: token && token.access_token
		};
	}
}

function mapDispatchToProps(dispatch, ownProps) {
	return {
		actions: bindActionCreators({destroyGoal}, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(injectSheet(styles)(GoalLink));
